module.exports = __webpack_public_path__ + "static/bootstrap-button-secondary-bbfd368145742672cb877da64319f1ae.png";